import tracker from '@reedexpo/digital-tracking';
import { isExhibitorDetailsPage } from './functions';

const trackRecommendationClicked = (item, source) => {
  try {
    tracker.track('Recommendation Engaged', {
      'Exhibitor ID': item.id,
      'Exhibitor Name': item.title,
      'Product Area': 'ACS',
      'Recommendation Type': item.recommendationType,
      'Recommendation Category': 'Exhibitor Recommendation',
      Source: source
    });
  } catch (error) {
    console.error(error);
  }
};

const trackRecommendationViewed = (item, source) => {
  console.debug('Tracking recommendation viewed:', item, source);
  try {
    const payload = {
      'Exhibitor ID': item.id,
      'Exhibitor Name': item.title,
      'Product Area': 'ACS',
      'Recommendation Type': item.recommendationType,
      'Recommendation Category': 'Exhibitor Recommendation',
      'Package Type': item.packageName ? item.packageName.toLowerCase() : '',
      Source: source
    };
    if (isExhibitorDetailsPage()) {
      payload.Component = 'exhibitor-details';
    }
    tracker.track('Recommendation Viewed', payload);
  } catch (error) {
    console.error(error);
  }
};

export default {
  trackRecommendationClicked,
  trackRecommendationViewed
};
